import { createContext, useContext } from 'react';
import invariant from 'tiny-invariant';
/**
 * __Is expanded context__
 *
 * A context for storing the isExpanded value of the ExpandableMenuItem.
 */
export var IsExpandedContext = /*#__PURE__*/createContext(null);

/**
 * __Set is expanded context__
 *
 * A context for storing a function that sets isExpanded value of the ExpandableMenuItem.
 */
export var SetIsExpandedContext = /*#__PURE__*/createContext(null);

/**
 * __Is child selected context__
 *
 * A context for storing the isChildSelected value of the ExpandableMenuItem.
 */
export var IsChildSelectedContext = /*#__PURE__*/createContext(null);

/**
 * __On expansion toggle context__
 *
 * A context for storing a function that triggers when isExpanded value of the ExpandableMenuItem is changed.
 */
export var OnExpansionToggleContext = /*#__PURE__*/createContext(null);

/**
 * __Level context__
 *
 * A context for storing the level value of the ExpandableMenuItem.
 */
export var LevelContext = /*#__PURE__*/createContext(0);
export var useIsExpanded = function useIsExpanded() {
  var context = useContext(IsExpandedContext);
  invariant(context !== null, 'useIsExpanded must be used within an ExpandableMenuItem');
  return context;
};
export var useSetIsExpanded = function useSetIsExpanded() {
  var context = useContext(SetIsExpandedContext);
  invariant(context !== null, 'useSetIsExpanded must be used within an ExpandableMenuItem');
  return context;
};
export var useIsChildSelected = function useIsChildSelected() {
  var context = useContext(IsChildSelectedContext);
  invariant(context !== null, 'useIsChildSelected must be used within an ExpandableMenuItem');
  return context;
};
export var useOnExpansionToggle = function useOnExpansionToggle() {
  return useContext(OnExpansionToggleContext);
};
export var useLevel = function useLevel() {
  return useContext(LevelContext);
};